import {
    CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST,
    CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS,
    CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE,
    DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST,
    DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS,
    DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE,
    FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE,
    UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST,
    UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS,
    UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE,
    RESET_ALL_OVER_PRINTING_DC_INWARD_MASTER_INFO,
    CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FORM,
    UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FORM,
    NAVIGATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS,
    NAVIGATE_ALL_OVER_PRINTING_DC_INWARD_MASTER,
    FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_FAILURE,
    SET_ACTIVE_KEY_ALL_OVER_PRINTING_INWARD,
    RESET_FORM_DATA_WITHOUT_ALL_OVER_PRINTING_INWARD_ID,
    SET_END_DATE_ALL_OVER_PRINTING_DC_INWARD,
    SET_START_DATE_ALL_OVER_PRINTING_DC_INWARD,
    SET_UNIT_NAME_ALL_OVER_PRINTING_DC_INWARD
} from './printingDcInwardHeader.actionsType';

export const ALL_OVER_PRINTING_DC_INWARD_MASTER = 'allOverPrintingDcInwardHeader';

let initialState = {
    loading: false,
    printingDcInwardHeader: [],
    pendingPrintingDC: [],
    printingDcInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: 0,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldIsInHouseProduction: false,
        fldRoundoff: 0
    },
    selectedState: {},
    errorMessage: '',
    activeKey: 1,
    printingInwardId: '',
    detailsId: [],
    singlePrintingDcInwardData: {},
    isPrintingDcInwardDetails: false,
    goBack: true,
    unitId: '',
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
};

export let allOverPrintingDcInwardHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST:
        case FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_REQUEST:
        case CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST:
        case UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST:
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST:
        case DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardHeader: updatePayload
            };
        case FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingPrintingDC: updatePayload
            };
        case CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                printingInwardId: updatePayload[0]?.fldID,
                detailsId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case SET_ACTIVE_KEY_ALL_OVER_PRINTING_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case RESET_ALL_OVER_PRINTING_DC_INWARD_MASTER_INFO:
            return {
                ...state,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                printingInwardId: '',
                detailsId: [],
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_ALL_OVER_PRINTING_INWARD_ID:
            return {
                ...state,
                printingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FORM:
        case UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FORM:
            return {
                ...state,
                loading: false,
                printingDcInwardHeaderForm: {
                    ...state.printingDcInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE:
        case FETCH_PENDING_ALL_OVER_PRINTING_PO_IN_INWARD_FAILURE:
        case CREATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE:
        case UPDATE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE:
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE:
        case DELETE_ALL_OVER_PRINTING_DC_INWARD_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS:
            return {
                ...state,
                isPrintingDcInwardDetails: true,
                singlePrintingDcInwardData: updatePayload.singlePrintingDcInwardData
            };
        case NAVIGATE_ALL_OVER_PRINTING_DC_INWARD_MASTER:
            return {
                ...state,
                isPrintingDcInwardDetails: false,
                goBack: false
            };
        case SET_UNIT_NAME_ALL_OVER_PRINTING_DC_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_ALL_OVER_PRINTING_DC_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_ALL_OVER_PRINTING_DC_INWARD:
            return {
                ...state,
                endDate: payload
            };
        default:
            return state;
    }
};
